import React, { useState } from 'react'
import './Accordion.css'

/**
 * Componente Accordion reutilizable
 * @param {Object} props
 * @param {string} props.title - Título del acordeón
 * @param {React.ReactNode} props.children - Contenido del acordeón
 * @param {boolean} props.defaultOpen - Si el acordeón debe estar abierto por defecto
 * @param {string} props.className - Clases CSS adicionales
 * @param {string} props.icon - Icono a mostrar junto al título
 */
const Accordion = ({ 
  title, 
  children, 
  defaultOpen = false, 
  className = '', 
  icon = null 
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={`accordion ${isOpen ? 'open' : ''} ${className}`}>
      <div 
        className="accordion-header" 
        onClick={toggleAccordion}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            toggleAccordion()
          }
        }}
      >
        <div className="accordion-title">
          {icon && <i className={`bi ${icon} me-2`}></i>}
          {title}
        </div>
        <div className="accordion-toggle">
          <i className={`bi ${isOpen ? 'bi-dash' : 'bi-plus'}`}></i>
        </div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          {children}
        </div>
      )}
    </div>
  )
}

export default Accordion
